<div class="grid flex justify-content-start align-items-center p-3" *ngIf="controller">
   <p-button icon="pi cm-plus" label="{{ 'ADD_SUBSECTION' | translate }}" (click)="aggiungiSottosezioni()" [text]="true" severity="primary" styleClass="font-bold border-primary" [ngClass]="col12Action()">
   </p-button>
   <p-button icon="pi cm-sort" label="{{ 'REORDER_SUBSECTIONS' | translate }}" (click)="ordinaSottosezioni()" [text]="true" severity="secondary" styleClass="font-bold" [ngClass]="col12Action()">
   </p-button>
   <p-button icon="pi cm-pencil" label="{{ 'EDIT_SECTION' | translate }}" (click)="modificaSezione()" [text]="true" severity="secondary" styleClass="font-bold" [ngClass]="col12Action()">
   </p-button>
   <p-button icon="pi cm-trash" label="{{ 'DELETE_SECTION' | translate }}" (click)="eliminaSezione()" [text]="true" severity="danger" styleClass="font-bold" [ngClass]="col12Action()">
   </p-button>
</div>

<div class="flex align-items-center justify-content-end w-full pr-8">
   <p-tag *ngIf="controller" [value]="keySection + section.KeyHelp" styleClass="p-tag-section"></p-tag>
</div>
<p-accordion (click)="accordionAction()"> <!-- [styleClass]="(!onMobile()) ? 'p-accordion' : 'p-accordion-overflowauto'" -->
   <p-accordionTab *ngFor="let subsection of section.ListSubSections;">
      <ng-template pTemplate="header"> 
         <div class="grid flex align-items-center w-full pt-2 -mb-2">
            <div [ngClass]="(controller) ? 'col-6 py-0 white-space-nowrap' : 'col-12 py-0'"><span class="font-bold">{{subsection.Title}}</span></div>
            <div *ngIf="controller" class="col-2 -mb-4 py-0 flex align-items-center justify-content-start"><p-tag [value]="keySubSection + subsection.KeyHelp" styleClass="p-tag-subsection"></p-tag></div>
            <div *ngIf="controller" class="col-4 flex justify-content-end gap-2 py-0">
               <p-button pTooltip="{{ 'ADD_ROW' | translate }}" tooltipPosition="bottom" icon="pi cm-plus" size="large" (click)="$event.stopPropagation(); aggiungiRiga(subsection)" [rounded]="false" [text]="true" severity="primary">
               </p-button>
               <p-button pTooltip="{{ 'REORDER_ROWS' | translate }}" tooltipPosition="bottom" icon="pi cm-sort" size="large" (click)="$event.stopPropagation(); riordinaRow(subsection)" [rounded]="false" [text]="true" severity="secondary">
               </p-button>
               <p-button pTooltip="{{ 'EDIT_SUBSECTION' | translate }}" tooltipPosition="bottom" icon="pi cm-pencil" size="large" (click)="$event.stopPropagation(); modificaSottosezione(subsection)" [rounded]="false" [text]="true" severity="secondary">
               </p-button>
               <p-button pTooltip="{{ 'DELETE_SUBSECTION' | translate }}" tooltipPosition="bottom" icon="pi cm-trash" size="large" (click)="$event.stopPropagation(); eliminaSottosezione(subsection)" [rounded]="false" [text]="true" severity="danger">
               </p-button>
            </div>
         </div>
      </ng-template>
      <app-helper-subsection [subsection]="subsection" [controller]="controller"></app-helper-subsection>
   </p-accordionTab>
</p-accordion>

<p-confirmDialog #confDialog>
   <ng-template pTemplate="footer">
      <div class="col-12 flex justify-content-center">
         <button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle" (click)="confDialog.accept()">
         </button>
         <button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle" (click)="confDialog.reject()">
         </button>
      </div>
   </ng-template>
</p-confirmDialog>